import { ref, onMounted, onUnmounted } from 'vue'

/**
 * 检测用户是否启用了"减少动态效果"系统设置
 */
export function useReducedMotion() {
  const prefersReducedMotion = ref(false)

  let mediaQuery: MediaQueryList | null = null

  function updatePreference() {
    prefersReducedMotion.value = mediaQuery?.matches ?? false
  }

  onMounted(() => {
    mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
    updatePreference()
    mediaQuery.addEventListener('change', updatePreference)
  })

  onUnmounted(() => {
    mediaQuery?.removeEventListener('change', updatePreference)
  })

  return prefersReducedMotion
}
